import { useEffect } from 'react';
import { useAppSelector, useUserSelector } from 'js/store/hooks';
import { pick, prop } from 'ramda';
import { useDispatch } from 'react-redux';

import * as actions from '../../../store/actions';

export const useSportsbookRootURL = () => {
    const { sportsbookRootURLLocaleMapping, defaultLocale } = useAppSelector(pick(['sportsbookRootURLLocaleMapping', 'defaultLocale']));
    const lang = useUserSelector(prop('lang'));
    const dispatch = useDispatch();

    useEffect(() => {
        if (!lang || !defaultLocale) {
            return;
        }

        const sportsbookRootURL = sportsbookRootURLLocaleMapping[lang] ?? sportsbookRootURLLocaleMapping[defaultLocale] ?? '';

        dispatch(actions.updateSportsbookRootURL({
            sportsbookRootURL
        }));
    }, [
        lang,
        dispatch,
        defaultLocale,
        sportsbookRootURLLocaleMapping
    ]);
};
